import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { ToastrService } from '../../services/toastr/toastr.service';
import { getFirstApiErrorMessage } from '../../utils/http-error-message';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorsService implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private auth: AuthService,
    private toast: ToastrService,
    private router: Router,
  ) {}

  private isPublicAuthRequest(url: string): boolean {
    const u = url.toLowerCase();
    return (
      u.includes('/login/colab') ||
      u.includes('auth/v1/login') ||
      u.includes('auth/v2/login')
    );
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isPublicAuthRequest(req.url)) {
      return next.handle(req);
    }

    const authService = this.injector.get(AuthService);
    const tokenizedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    return next.handle(tokenizedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const isAbortedRequest =
          error.status === 0 &&
          (error.error instanceof ProgressEvent || error.statusText === 'Unknown Error');

        if (isAbortedRequest) {
          return throwError(() => error);
        }

        if (error.status === 401) {
          this.auth.removeToken();
          void this.router.navigate(['/auth'], { queryParamsHandling: 'preserve' });
          this.toast.error(
            'Seu token de acesso expirou. Por favor faça login novamente.',
          );
        }

        const firstErrorMessage = getFirstApiErrorMessage(error);

        if (firstErrorMessage) {
          this.toast.error(firstErrorMessage);
        } else if (error.message) {
          this.toast.error(error.message);
        }

        return throwError(() => error);
      }),
    );
  }
}
